export default {"src":"/_next/static/media/hero_fab.4b943669.gif","height":700,"width":1200,"blurWidth":0,"blurHeight":0};